var _ = require('underscore');
var TorsoListView = require('backbone-torso/modules/ListView');
var TorsoEvents = require('backbone-torso/modules/Events');
var PaymentMethodListItemView = require('./PaymentMethodListItemView');
var patientStoredPaymentMethodsTemplate = require('./patientStoredPaymentMethodsTemplate.hbs');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var StoredPaymentMethodDataBehavior = require('./StoredPaymentMethodDataBehavior');
var applicationUtils = require('./../applicationUtils');

/**
 * View for displaying a patients wallet payments
 *
 * @class PatientStoredPaymentMethodsView
 * @constructor
 */
module.exports = TorsoListView.extend({
  tagName: 'section',
  className: 'index index--wallet',
  template: patientStoredPaymentMethodsTemplate,
  itemView: PaymentMethodListItemView,
  itemContainer: 'stored-payment-method-items',

  events: {
    'click [data-refresh-page-button]': 'fetchContent'
  },

  behaviors: {
    storedPaymentMethods: {
      behavior: StoredPaymentMethodDataBehavior,
      alwaysFetch: true,
      renderOnFetch: true,
      updateEvents: ['view:financialConfigLoaded', { 'change': financialFeatureConfigModel }],
      ids: function(cache) {
        var isStoredPaymentMethodEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled();
        if (isStoredPaymentMethodEnabled) {
          return cache.fetchIdsForPatient(this.view._patientVecnaId);
        }
        return {
          skipObjectRetrieval: true,
          forceFetchedEvent: true
        };
      }
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   * @param options.patientVecnaId {String} of the patient owning the payment methods
   */
  initialize:function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    this.__itemContext = {patientVecnaId: this._patientVecnaId};

    var storedPaymentMethodsDataBehavior = this.getBehavior('storedPaymentMethods');
    this.collection = storedPaymentMethodsDataBehavior.data.privateCollection;

    this.listenTo(this.collection, 'fetchStoredPaymentMethods', this.fetchContent);
    this.listenTo(TorsoEvents, 'payment-methods:updated', this.fetchContent);
    this.listenTo(this.collection, 'add remove change:valid', this.render);
    _.bindAll(this, '_setFinancialConfigLoaded');
    financialFeatureConfigModel.loadOnce()
      .then(this._setFinancialConfigLoaded);
  },

  prepareFields: {
    currentApplication: applicationUtils.currentApplication,
    patientVecnaId: '_patientVecnaId',
    incompleteStoredPaymentMethods: function() {
      var hasModels = !this.collection.isEmpty();
      var hasInvalidModel = !!this.collection.find(function(model) {
        return !model.get('valid');
      });
      return hasModels && hasInvalidModel;
    }
  },

  /**
   * Marks that the financial feature config has finished loading
   * @method setFinancialConfigLoaded
   * @private
   */
  _setFinancialConfigLoaded: function() {
    this.set('financialConfigLoaded', true);
  },

  /**
   * Re-fetches the data used by this view.
   * @method fetchContent
   */
  fetchContent: function() {
    this.getBehavior('storedPaymentMethods').fetch();
  }
});
